module.exports = __webpack_public_path__ + "static/img/pin-no-activity-inactive.fdf2fde.svg";